import { FormEvent, useState } from 'react'
import { platformApi } from '../platform/public'
import { Brand } from '../../ui/foundation/LegacyPrimitives'

function slugify(value: string) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '')
}

export function TenantBootstrap({ onCreated }: { onCreated: () => Promise<void> }) {
  const [showForm, setShowForm] = useState(false)
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)
  const [checking, setChecking] = useState(false)

  async function checkAccess() {
    setChecking(true)
    setError('')
    await onCreated()
    setChecking(false)
  }

  async function submit(event: FormEvent) {
    event.preventDefault()
    setBusy(true)
    setError('')
    const result = await platformApi.workspace.bootstrapTenant(name, slug || slugify(name))
    setBusy(false)
    if (result.error) setError(result.error.message)
    else await onCreated()
  }

  return <main className="auth-page"><section className="auth-card wide">
    <Brand />
    <p className="eyebrow" style={{ marginTop: '1.7rem' }}>THIẾT LẬP WORKSPACE</p>
    <h1 style={{ marginTop: 0 }}>Chọn cách bắt đầu</h1>
    <p className="muted">Workspace là không gian dữ liệu riêng của một agency, dùng để quản lý thành viên, campaign và quyền truy cập.</p>
    <div className="notice" role="status">Nếu bạn được mời làm Operator hoặc Client Viewer, không tạo workspace mới. Hãy chờ Agency Admin cấp quyền rồi kiểm tra lại tài khoản.</div>
    <div className="stack" style={{ marginTop: '1rem' }}>
      <button type="button" className="primary" disabled={checking} onClick={() => void checkAccess()}>{checking ? 'Đang kiểm tra…' : 'Kiểm tra quyền truy cập'}</button>
      {!showForm ? <button type="button" className="link-button" onClick={() => { setShowForm(true); setError('') }}>Tôi là quản trị viên đầu tiên — tạo workspace mới</button> : <>
        <div className="notice">Chỉ tiếp tục khi bạn đại diện agency và cần khởi tạo workspace đầu tiên. Sau khi tạo, bạn sẽ trở thành Agency Admin của workspace này.</div>
        <form className="stack" onSubmit={submit}>
          <label>Tên workspace / agency<input required value={name} onChange={(event) => { setName(event.target.value); setSlug(slugify(event.target.value)) }} /></label>
          <label>Đường dẫn workspace (slug)<input required pattern="[a-z0-9]+(?:-[a-z0-9]+)*" value={slug} onChange={(event) => setSlug(slugify(event.target.value))} /></label>
          {error && <div className="notice error">{error}</div>}
          <button className="primary" disabled={busy}>{busy ? 'Đang tạo…' : 'Tạo workspace agency'}</button>
        </form>
        <button type="button" className="link-button" onClick={() => { setShowForm(false); setError('') }}>Quay lại hướng dẫn</button>
      </>}
    </div>
  </section></main>
}
